module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_10X_DCIS.7672c5c4.png";